import { Component } from '@angular/core';
import { ApiRequestService } from './api-request.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'DFQ';
  LOGOURL:string ="";
  constructor(public restAPI:ApiRequestService){
    // if (location.host.indexOf('staging')>=0 || location.host.indexOf('local')>=0) {
    //   this.LOGOURL = 'https://staging.protoexpress.com/';
    // }else{
    //   this.LOGOURL = 'https://www.protoexpress.com/';
    // }
    if (location.host.indexOf('staging')>=0 || location.host.indexOf('local')>=0) {
      window.open("https://staging.protoexpress.com/customer-portal/design-quote/", '_self');
    }else{
      window.open("https://www.protoexpress.com/customer-portal/design-quote/", '_self');
    }
    
    //window.location.href = "https://www.protoexpress.com/customer-portal/design-quote/";
  }
}
